var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCanvaIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3232_9652)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#24BECA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0998 16.1625C16.4623 17.025 15.6373 17.925 14.5498 18.6C13.4998 19.275 12.2998 19.8 10.8748 19.8C9.56225 19.8 8.47475 19.125 7.87475 18.5625C6.97475 17.7 6.48725 16.4625 6.33725 15.3C5.88725 11.7 8.09975 6.93747 11.5123 4.87498C12.2998 4.38748 13.1623 4.16248 13.9873 4.16248C15.6373 4.16248 16.8748 5.32498 17.0248 6.74997C17.1748 8.02497 16.6873 9.11247 15.2623 9.82498C14.5498 10.2 14.1748 10.1625 14.0623 10.0125C13.9873 9.89997 14.0248 9.71247 14.1748 9.59997C15.4873 8.51248 15.5248 7.61247 15.3748 6.33748C15.2623 5.51248 14.7373 4.98748 14.1373 4.98748C11.5498 4.98748 7.79975 10.8 8.32475 15C8.51225 16.65 9.52475 18.5625 11.6248 18.5625C12.2998 18.5625 13.0498 18.375 13.6873 18.0375C15.1498 17.2875 15.7873 16.7625 16.6498 15.5625C16.7623 15.4125 16.8748 15.225 16.9873 15.075C17.0623 14.925 17.2123 14.8875 17.3248 14.8875C17.4373 14.8875 17.5873 15 17.5873 15.1875C17.5873 15.3 17.5498 15.525 17.3998 15.7125C17.3623 15.7875 17.2498 16.0125 17.0998 16.1625Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3232_9652"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanvaIcon1);
export default __webpack_public_path__ + "static/media/canva-icon (1).6e043f73d762f43959bdebf2a7188e3f.svg";
export { ForwardRef as ReactComponent };